export default "__VITE_ASSET__CILfnsoY__"